import {
  BANKVERIFICATIONSTATUS,
  IBankVerification,
  IPayoutInfluencer,
  PAYOUTSTATUS,
} from "@shared/lib/types/briefCampains";

export type VerifiedBankDetails = {
  accountName: string;
  accountNumber: string;
  ifscCode: string;
  bankName?: string;
  branch?: string;
  city?: string;
  state?: string;
};

export function isBankVerified(
  status?: BANKVERIFICATIONSTATUS,
  bankVerification?: Partial<IBankVerification>
): boolean {
  return (
    status === BANKVERIFICATIONSTATUS.Verified ||
    bankVerification?.status === BANKVERIFICATIONSTATUS.Verified
  );
}

export function getPayoutInfluencerBankDetails(
  record: IPayoutInfluencer
): VerifiedBankDetails | null {
  return getVerifiedBankDetails(
    record.bankVerification,
    record.bankVerificationStatus
  );
}

export function getVerifiedBankLocation(
  details: VerifiedBankDetails | null
): string {
  if (!details) return "";
  return [details.bankName, details.branch, details.city, details.state]
    .filter(Boolean)
    .join(" · ");
}

export function getVerifiedBankDetails(
  bankVerification?: Partial<IBankVerification>,
  status?: BANKVERIFICATIONSTATUS
): VerifiedBankDetails | null {
  if (!isBankVerified(status, bankVerification) || !bankVerification) {
    return null;
  }

  const response = bankVerification.verificationResponse;
  const ifscDetails = response?.ifsc_details;
  const accountName =
    bankVerification.bankAccountName || response?.name_at_bank || "";
  const accountNumber = bankVerification.bankAccountNumber || "";
  const ifscCode = bankVerification.ifscCode || ifscDetails?.ifsc || "";

  if (!accountName && !accountNumber && !ifscCode) {
    return null;
  }

  return {
    accountName,
    accountNumber,
    ifscCode,
    bankName: response?.bank_name || ifscDetails?.bank,
    branch: response?.branch || ifscDetails?.branch,
    city: response?.city || ifscDetails?.city,
    state: ifscDetails?.state,
  };
}

export function getBankVerificationTagColor(
  status?: BANKVERIFICATIONSTATUS
): string {
  switch (status) {
    case BANKVERIFICATIONSTATUS.Verified:
      return "green";
    case BANKVERIFICATIONSTATUS.Failed:
      return "red";
    case BANKVERIFICATIONSTATUS.Pending:
      return "orange";
    default:
      return "default";
  }
}

export function getPayoutStatusTagColor(status?: PAYOUTSTATUS): string {
  switch (status) {
    case PAYOUTSTATUS.Success:
      return "green";
    case PAYOUTSTATUS.Failed:
      return "red";
    case PAYOUTSTATUS.Pending:
      return "orange";
    default:
      return "default";
  }
}

export function getPayoutBankVerificationToken(
  record: IPayoutInfluencer
): string | undefined {
  const token = record.bankVerificationToken?.token;
  return token?.trim() || undefined;
}
